import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';



export class ZrSelectSelectionComponent implements OnInit {
   selects: any[] = [];
   model: any = '';
   clear?: boolean = false;
   disabled?: boolean = false;

   modelChange = new EventEmitter();

  constructor() { };

  ngOnInit() {
  };

  select(event: any) {
    this.model = event;
    this.modelChange.emit(event);
  };

  clearValue() {
    this.model = null;
    this.modelChange.emit(this.model);
  };

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'zr-select-selection',
  template: `
    <div class="lz-select-selection">
      <div class="lz-select-selection-select">
        <select class="form-control m-input" [ngModel]="model" (ngModelChange)="select($event)" disabled="{{disabled}}">
          <option *ngFor="let option of selects" [value]="option.value" [disabled]="option.disabled">{{option.text}}</option>
        </select>
        <i [hidden]="!clear||model==null" (click)="clearValue()" class="la la-times-circle"></i>
      </div>
    </div>`,
  styles: [`
    .lz-select-selection-select {
        position: relative;
    }
    .lz-select-selection-select i {
      display: inline-block;
      position: absolute;
      top: 50%;
      right: 20px;
      margin-top: -9px;
      background: #fff;
      cursor: pointer;
    }  
    .lz-select-selection-select i:hover {
      color: #7148d2;
    }
    .lz-select-selection-select .lz-select-selection-wrapper {
      display: grid;
      grid-template-columns: 16% 84%;
      grid-template-rows: auto;
    }`
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'selects': [{ type: Input },],
'model': [{ type: Input },],
'clear': [{ type: Input },],
'disabled': [{ type: Input },],
'modelChange': [{ type: Output },],
};
};

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
